import { render, staticRenderFns } from "./initRoom.vue?vue&type=template&id=49f709c8&scoped=true&"
import script from "./initRoom.vue?vue&type=script&lang=js&"
export * from "./initRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f709c8",
  null
  
)

export default component.exports